import { styles as accordionSection } from './accordionSection/styles';
import { styles as accountPage } from './accountPage/styles';
import { styles as actionMenu } from './actionMenu/styles';
import { styles as activitiesMultiselect } from './activitiesMultiselect/styles';
import { styles as activityDataValidation } from './activityDataValidation/styles';
import { styles as addressColumnWidth } from './addressColumnWidth/styles';
import { styles as adminConfigTable } from './adminConfigTable/styles';
import { styles as appAccordion } from './appAccordion/styles';
import { styles as appActivityDataDetailForm } from './appActivityDataDetailForm/styles';
import { styles as appActivityDataStepSidebar } from './appActivityDataStepSidebar/styles';
import { styles as appBanner } from './appBanner/styles';
import { styles as appCard } from './appCard/styles';
import { styles as appCheckMark } from './appCheckMark/styles';
import { styles as appChip } from './appChip/styles';
import { styles as appDataTable } from './appDataTable/styles';
import { styles as appEditableRowTable } from './appEditableRowTable/styles';
import { styles as appEmptyState } from './appEmptyState/styles';
import { styles as appEventGroup } from './appEventGroup/styles';
import { styles as appFilterWithoutOrder } from './appFilterWithoutOrder/styles';
import { styles as appHeader } from './appHeader/styles';
import { styles as appLink } from './appLink/styles';
import { styles as appMenubar } from './appMenubar/styles';
import { styles as appMessage } from './appMessage/styles';
import { styles as appModal } from './appModal/styles';
import { styles as appRoutedTabsList } from './appRoutedTabsList/styles';
import { styles as appSection } from './appSection/styles';
import { styles as appSeparator } from './appSeparator/styles';
import { styles as appSignature } from './appSignature/styles';
import { styles as appSplashCard } from './appSplashCard/styles';
import { styles as appSurface } from './appSurface/styles';
import { styles as appTable } from './appTable/styles';
import { styles as appText } from './appText/styles';
import { styles as appTreeSelect } from './appTreeSelect/styles';
import { styles as appValueSection } from './appValueSection/styles';
import { styles as button } from './button/styles';
import { styles as checkRadio } from './checkRadio/styles';
import { styles as controlObjectIdentify } from './controlObjectIdentify/styles';
import { styles as controlObjectRepresentativeModal } from './controlObjectRepresentativeModal/styles';
import { styles as controlObjectSummaryCard } from './controlObjectSummaryCard/styles';
import type { CssGeneratorContext, DesignTokenGetter } from './css-generator.model';
import { styles as customBoxShadow } from './customBoxShadow/styles';
import { styles as customLineHeight } from './customLineHeight/styles';
import { styles as customPlaceholder } from './customPlaceholder/styles';
import { styles as customTooltip } from './customTooltip/styles';
import { styles as customTruncate } from './customTruncate/styles';
import { styles as datePicker } from './datePicker/styles';
import { styles as deficiencyStepTable } from './deficiencyStepTable/styles';
import { styles as eventCalendar } from './eventCalendar/styles';
import { styles as eventInputState } from './eventInputState/styles';
import { styles as expandableFilterSection } from './expandableFilterSection/styles';
import { styles as fileUploadZone } from './fileUploadZone/styles';
import { styles as footer } from './footer/styles';
import { styles as groupedTable } from './groupedTable/styles';
import { styles as headings } from './headings/styles';
import { styles as idleSessionModal } from './idleSessionModal/styles';
import { styles as incidentModal } from './incidentModal/styles';
import { styles as input } from './input/styles';
import { styles as inspectionActivitySelect } from './inspectionActivitySelect/styles';
import { styles as inspectionOtherParticipantModal } from './inspectionOtherParticipantModal/styles';
import { styles as inspectionParticipantCard } from './inspectionParticipantCard/styles';
import { styles as inspectionParticipantSection } from './inspectionParticipantSection/styles';
import { styles as inspectionReportViolationsSection } from './inspectionReportViolationsSection/styles';
import { styles as inspectionRepresentativeModal } from './inspectionRepresentativeModal/styles';
import { styles as inspectionStepBlockedView } from './inspectionStepBlockedView/styles';
import { styles as inspectionStepPageTitle } from './inspectionStepPageTitle/styles';
import { styles as inspectionTables } from './inspectionTables/styles';
import { styles as inspectionTag } from './inspectionTag/styles';
import { styles as inspectionValidationSummary } from './inspectionValidationSummary/styles';
import { styles as legislationTreeSelect } from './legislationTreeSelect/styles';
import { styles as multilineTextInput } from './multilineTextInput/styles';
import { styles as multiselect } from './multiselect/styles';
import { styles as notificationModal } from './notificationModal/styles';
import { styles as overlay } from './overlay/styles';
import { styles as paginator } from './paginator/styles';
import { styles as participantSignatureModal } from './participantSignatureModal/styles';
import { styles as pdfViewer } from './pdfViewer/styles';
import { styles as presetText } from './presetText/styles';
import { styles as questionnaireStep } from './questionnaireStep/styles';
import { styles as reportStatusTag } from './reportStatusTag/styles';
import { styles as riskGroupBubble } from './riskGroupBubble/styles';
import { styles as rowInvalid } from './rowInvalid/styles';
import { styles as select } from './select/styles';
import { styles as selects } from './selects/styles';
import { styles as sgpAnimalTreeSelect } from './sgpAnimalTreeSelect/styles';
import { styles as staticToast } from './staticToast/styles';
import { styles as stepper } from './stepper/styles';
import { styles as switchField } from './switchField/styles';
import { styles as toastProgress } from './toastProgress/styles';
import { styles as userInfo } from './userInfo/styles';

/** The theme's `dt` returns `string | number | undefined`; the generators take a `string`, so it is coerced here. */
type ThemeDesignTokenGetter = (path: string) => string | number | undefined;

/** Every group's styles in cascade order: of two rules with the same specificity, the later one wins. */
const orderedStyles: readonly ((context: CssGeneratorContext) => string)[] = [
	input,
	expandableFilterSection,
	customPlaceholder,
	inspectionTables,
	appEditableRowTable,
	deficiencyStepTable,
	addressColumnWidth,
	customTruncate,
	headings,
	appHeader,
	appModal,
	appSignature,
	appSection,
	appAccordion,
	appActivityDataDetailForm,
	activityDataValidation,
	appActivityDataStepSidebar,
	accordionSection,
	presetText,
	multilineTextInput,
	appDataTable,
	button,
	groupedTable,
	activitiesMultiselect,
	appTreeSelect,
	appCheckMark,
	appChip,
	appMessage,
	selects,
	customLineHeight,
	paginator,
	appValueSection,
	customBoxShadow,
	footer,
	appMenubar,
	participantSignatureModal,
	customTooltip,
	multiselect,
	select,
	inspectionActivitySelect,
	datePicker,
	overlay,
	stepper,
	inspectionStepBlockedView,
	inspectionStepPageTitle,
	inspectionParticipantCard,
	inspectionParticipantSection,
	inspectionOtherParticipantModal,
	inspectionRepresentativeModal,
	controlObjectRepresentativeModal,
	controlObjectSummaryCard,
	controlObjectIdentify,
	incidentModal,
	inspectionValidationSummary,
	appEventGroup,
	appLink,
	fileUploadZone,
	questionnaireStep,
	legislationTreeSelect,
	sgpAnimalTreeSelect,
	appFilterWithoutOrder,
	actionMenu,
	rowInvalid,
	appSplashCard,
	appBanner,
	staticToast,
	toastProgress,
	appCard,
	appTable,
	eventCalendar,
	reportStatusTag,
	appEmptyState,
	inspectionReportViolationsSection,
	riskGroupBubble,
	appText,
	appSurface,
	appSeparator,
	checkRadio,
	pdfViewer,
	inspectionTag,
	notificationModal,
	idleSessionModal,
	eventInputState,
	adminConfigTable,
	appRoutedTabsList,
	accountPage,
	userInfo,
	switchField,
];

export const css = ({ dt: themeDt }: { dt: ThemeDesignTokenGetter }) => {
	const dt: DesignTokenGetter = (path) => String(themeDt(path) ?? '');
	return `${orderedStyles.map((styles) => styles({ dt })).join('\n')}\n`;
};
